export const DISPLAY_STYLE = {
    INPUT: 'input',
    BUTTON: 'button'
};

export const BUTTON_STYLE = {
    RECTANGLE: 'rectangle',
    OVAL: 'oval'
};